import {transform, createSelector} from 'helpers';

export const parents = createSelector(
  [ state => state.goals.index, state => state.activities.index, state => state.diary.index ],
  ( milestones, activities, diary ) => transform({ ...activities, ...milestones, ...diary }, (result, { goal_id, goalId, parent_id, id }) => {
    if (goal_id || goalId || parent_id) {
      result[id] = goal_id || goalId || parent_id;
    }
  })
);
